<mat-dialog-content class="rounded-0">
  <div class="d-flex justify-content-between align-items-start">
    <h5 class="fw-semibold">Hinweise zur Zuweisung</h5>
    <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
      (click)="onClose()">
  </div>

  <p class="acd-intro">
    Einige Zuweisungen wurden nicht gesetzt, weil der Kanal bereits einer anderen
    Zeitschaltuhr gehört:
  </p>

  <table class="acd-table">
    <thead>
      <tr>
        <th>Station</th>
        <th>Nicht gesetzte Typen</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data.rows">
        <td>
          <span class="acd-station">
            <avs-station-meta-info *ngIf="row.station"
              [metaInformation]="row.metaInformation" [x]="row.station.x" [y]="row.station.y"
              layout="inline"></avs-station-meta-info>
            <span class="acd-name">{{ row.name }}</span>
          </span>
        </td>
        <td>
          <span class="acd-types">
            <span class="acd-type-block" *ngFor="let b of typeBlocks(row.types)"
              [style.background]="b.color" [style.color]="b.text">{{ b.label }}</span>
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="d-flex justify-content-end mt-4 border-top pt-3">
    <button class="btn btn-sm btn-outline-secondary rounded-0" (click)="onClose()">OK</button>
  </div>
</mat-dialog-content>
